import type { UIConfig } from '@/core/data/config/uiConfig.interface';

export class HomeViewService {
  private readonly uiConfig: UIConfig | null;

  constructor(uiConfig: UIConfig | null) {
    this.uiConfig = uiConfig;
  }
}
